import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { LoggingService } from '../shared/services/logging/logging.service';
import { Observable } from 'rxjs';
import { UserSetting } from './store';
import { map, tap } from 'rxjs/operators';
import { IGenericResponse } from '../shared';

@Injectable({
    providedIn: 'root'
})
export class UserSettingService {
    private uri = `${environment.apiLocation}/UserSetting`;
    constructor(private http: HttpClient, private log: LoggingService) {}

    public get(EmployeeListID: string, EmpSettingID?: number): Observable<Array<UserSetting>> {
        return this.http
            .post<Array<UserSetting>>(this.uri, {
                EmployeeListID,
                EmpSettingID
            })
            .pipe(
                tap(data =>
                    this.log.verbose({
                        type: 'UserSettingService:getUserSetting',
                        data
                    })
                ),
                map(this.mapSettings),
                tap(data =>
                    this.log.verbose({
                        type: 'UserSettingService:getUserSetting:mapped',
                        data
                    })
                )
            );
    }
    public put(
        setting: Array<Partial<UserSetting>>
    ): Observable<IGenericResponse<UserSetting>> {
        this.log.verbose({
            type: 'UserSettingService:putUserSetting',
            setting
        });
        return this.http
            .put<IGenericResponse<UserSetting>>(this.uri, {
                UserSettingList: [
                    ...setting.map(x => ({
                        EmployeeListID: x.EmployeeListID,
                        EmpSettingID: x.EmpSettingID,
                        EmpSettingType: x.EmpSettingType,
                        EmpSettingValue:
                            x.CtrlType.toLocaleLowerCase() === 'checkbox'
                                ? x.EmpSettingValue
                                    ? '1'
                                    : '0'
                                : x.EmpSettingValue
                    }))
                ]
            })
            .pipe(
                tap(data =>
                    this.log.verbose({
                        type: 'UserSettingService:putUserSetting:response',
                        data
                    })
                ),
                map(resp => ({
                    ...resp,
                    Items: [...this.mapSettings(resp.Items)]
                })),
                tap(data =>
                    this.log.verbose({
                        type:
                            'UserSettingService:putUserSetting:response:mapped',
                        data
                    })
                )
            );
    }
    private mapSettings(settings: Array<UserSetting>): Array<UserSetting> {
        return settings
            .filter(x => x !== null && x !== undefined)
            .map(x => ({
                ...x,
                Validation: x.Isconfirmrequired ? 'confirm' : '',
                EmpSettingValue:
                    x.CtrlType.toLocaleLowerCase() === 'checkbox'
                        ? x.EmpSettingValue === 'true' ||
                          x.EmpSettingValue === true ||
                          x.EmpSettingValue === 1 ||
                          x.EmpSettingValue === '1'
                            ? '1'
                            : '0'
                        : x.EmpSettingValue
            }));
    }
}
